import { D } from "@angular/cdk/bidi-module.d-D-fEBKdS";

export class Commonvariables {
    static Configuration = class {
        static emailPattern =
            "^[a-zA-Z0-9+]+(?:.*_*[a-zA-Z0-9+]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$";
        static emailPattern2 =
            /^(?!.*\.{2})([a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+([\.][a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+)*)@((([\-]?[a-zA-Z0-9]){2,}[\.])*(([a-zA-Z0-9][\-]?))+).(([\.]([a-zA-Z0-9][\-]?){2,}([a-zA-Z0-9])*)+)$/;
    };
}

export const BackgroundTaskTopics = {
    Billing: "billing",
    Expense: "expense",
    CataLog: "catalog",
    Notification: "notification",
    Export: "export",
    GradeImport: "gradeimport"
};

export const BackgroundTaskKeys = {
    BulkInviteEmployees: 'BulkInviteEmployees',
    BulkApprovalAction: 'BulkApprovalAction',
    BulkUniversalImportEmployees: 'BulkUniversalImportEmployees',
    BulkExportExpensesAction: 'BulkExportExpensesAction',
    BulkUpdateExpenseApprovers: 'BulkUpdateExpenseApprovers',
    BulkCostCentreImport: 'BulkCostCentreImport',
    BulkAdditionalFieldDropdownValuesImport: 'BulkAdditionalFieldDropdownValuesImport',
    BulkUniversalCostCentreApprovers: 'BulkUniversalCostCentreApprovers',
    BulkUniversalAdvanceClaimantPolicy: 'BulkUniversalAdvanceClaimantPolicy',
    BulkImportXeroContacts: "BulkImportXeroContacts",
    BulkUniversalImportCustomers: "BulkUniversalImportCustomers",
    BulkUniversalImportCounterApprover: "BulkUniversalImportCounterApprover",
    BulkImportEmployees: 'BulkImportEmployees',
    BulkCreditCardExpensesImport: "BulkCreditCardExpensesImport",
    BulkCompanyAssignToEmployee: "BulkCompanyAssignToEmployee",
    BulkUniversalImportCategories: 'BulkUniversalImportCategories',
    BulkUniversalImportFxRate: 'BulkUniversalImportFxRate',
    XeroTokenExpiryNotification: "XeroTokenExpiryNotification",
    BulkInviteVendors: 'BulkInviteVendors',
    BulkImportAssignCreditCard: "BulkImportAssignCreditCard",
    BulkImportGrades: 'BulkImportGrades',
    BulkImportVendorGrades: 'BulkImportVendorGrades',
    SaveReceiptsInBulk: "SaveReceiptsInBulk"
}

export const BackgroundTaskNotificationHeaders = {
    BulkInviteEmployees: 'ManageEmployeeImportingHeader',
    BulkApprovalAction: 'FinanceApprovingExpensesHeader',
    BulkApprovalActionApprover: 'ApproverApprovingExpensesHeader',
    BulkExportExpensesAction: 'ExportExpensesHeader',
    BulkUniversalImportEmployees: 'BulkUniversalImportEmployeesHeader',
    BulkCostCentreImport: 'BulkCostCentreImportHeader',
    BulkAdditionalFieldDropdownValuesImport: 'BulkAdditionalFieldDropdownValuesImportHeader',
    BulkUniversalCostCentreApprovers: 'BulkUniversalCostCentreApproversHeader',
    BulkUniversalAdvanceClaimantPolicy: 'BulkUniversalClaimantAdvancePolicyHeader',
    BulkUniversalImportCustomers: 'BulkUniversalImportCustomersHeader',
    BulkImportEmployees: 'BulkImportEmployeesHeader',
    BulkCreditCardExpensesImport: 'BulkCreditCardExpensesImportHeader',
    BulkCompanyAssignToEmployee: 'BulkCompanyAssignToEmployeeHeader',
    BulkUniversalImportCategories: 'BulkUniversalImportCategoriesHeader',
    BulkUniversalImportCounterApprover: "BulkUniversalImportCounterApproverHeader",
    BulkUniversalImportFxRate: "BulkUniversalImportFxRateHeader",
    XeroTokenExpiryNotification: "Xero Token Expiry Notification",
    BulkInviteVendors: 'VendorImportingHeader',
    BulkImportAssignCreditCard: 'BulkImportAssignCreditCardHeader',
    BulkImportGrades: 'BulkImportGradesHeader',
    BulkImportVendorGrades: 'BulkImportVendorGradesHeader',
    CCDragAndDropImportHeader: 'ccdraganddropimportheader',
    SaveReceiptsInBulk: "SaveReceiptsInBulkHeader"
}

export const BackgroundTaskNotificationBody = {
    BulkInviteEmployees: "ManageEmployeeImportingBody",
    BulkUpdateEmployees: "ManageEmployeeUpdatingBody",
    BulkApprovalAction: "FinanceApprovingExpensesBody",
    BulkApprovalActionApprover: "ApproverApprovingExpensesBody",
    BulkExportExpensesAction: "ExportExpensesBody",
    BulkUniversalImportEmployees: "BulkUniversalImportEmployeesBody",
    BulkUpdateExpenseApprovers: "BulkUpdateExpenseApproversBody",
    BulkCostCentreImport: "BulkCostCentreImportBody",
    BulkAdditionalFieldDropdownValuesImport: 'BulkAdditionalFieldDropdownValuesImportBody',
    BulkUniversalCostCentreApprovers: "BulkUniversalCostCentreApproversBody",
    BulkUniversalAdvanceClaimantPolicy: "BulkUniversalClaimantAdvancePolicyBody",
    BulkUniversalImportCustomers: "BulkUniversalImportCustomersBody",
    BulkImportEmployees: "BulkImportEmployeesBody",
    BulkCompanyAssignToEmployee: "BulkCompanyAssignToEmployeeBody",
    BulkCreditCardExpensesImport: "BulkCreditCardExpensesImportBody",
    BulkUniversalImportCategories: 'BulkUniversalImportCategoriesBody',
    BulkUniversalImportCounterApprover: "BulkUniversalImportCounterApproverBody",
    BulkUniversalImportFxRate: "BulkUniversalImportFxRateBody",
    BulkInviteVendors: "VendorsImportingBody",
    BulkUpdateVendors: "VendorsUpdatingBody",
    BulkImportAssignCreditCard: "BulkImportAssignCreditCardBody",
    BulkImportGradeBody: 'BulkImportGradeBody',
    BulkImportVendorGrades: 'BulkImportVendorGradesBody',
    SaveReceiptsInBulk: "SaveReceiptsInBulkBody"
};

export const storeURLs = {
    playStore:
        "https://play.google.com/store/apps/details?id=com.expenseondemand.soloexpenses",
    appStore: "https://apps.apple.com/in/app/expenseondemand-for-smb/id643685343",
    website: "https://www.expenseondemand.com/",
};

export const socialMediaLinks = {
    facebook:
        "http://www.facebook.com/pages/Solo-Expenses/597280680311359?fref=ts",
    linkedIn: "https://www.linkedin.com/company/4830988",
    twitter: "https://twitter.com/soloexpenses",
    youtube: "https://www.youtube.com/channel/UCY3WsQPGK84vCqNjzYuRukw",
};

export const privacyPolicyURl =
    "../ExpenseOnDemand-SMB-Version-Privacy-Policy-V2.pdf";
export const termsOfServiceURl = "https://cdn.prod.website-files.com/653a83594795190d35b45ab8/693f9a29641dd523f0ccaea7_ExpenseOnDemand-SMB-TOS-August%20_2025_V10.1.pdf";

export const mileageRatedigitConfig = 4;

export const HowDoIVideoLinks: any = {
    SetupOrganisation:
        "https://www.youtube.com/embed?list=PLugzlMICZR8hcA-cqHUPsYv_BSywbq1Jj",
    CurrencySetup:
        "https://www.youtube.com/embed?list=PLugzlMICZR8hVIC09-KTCOQXyuNxjooE4",
    DeleteTestData:
        "https://www.youtube.com/embed?list=PLugzlMICZR8jCNQAw9AqnlYjbwYpnvTXp",
    ManageEmployees:
        "https://www.youtube.com/embed?list=PLugzlMICZR8iepD3e_NdmiBl8C6TjA33P",
    AssignApprovers:
        "https://www.youtube.com/embed?list=PLugzlMICZR8htXq_SlLwmdjUQpMmUgpLu",
    ConfigureApproverRules: "https://www.youtube.com/embed?list=PLugzlMICZR8jd_goUXDkTjo5kUNCUy7Nw",
    AssignApproversToClaimants: "https://www.youtube.com/embed?list=PLugzlMICZR8htXq_SlLwmdjUQpMmUgpLu",
    // AssignApproversToCostCentre: "https://www.youtube.com/embed?list=PLugzlMICZR8jd_goUXDkTjo5kUNCUy7Nw",
    SetupBasicMileage:
        "https://www.youtube.com/embed/videoseries?si=W4sAuNiR-8ML55fX&list=PLugzlMICZR8ijFGfIKwcXLrHhz3FUt94l",
    YesPayBizPortal:
        "https://www.youtube.com/embed?list=PLugzlMICZR8h-Psh1p9IHyPLzBr9vVUXk",
    // FMOneStepApproval: "https://player.vimeo.com/video/349615133",
    // CreateExpense: "https://player.vimeo.com/video/260244296",
    // ExpenseList: "https://player.vimeo.com/video/263002780",
    // MyExpenses: "https://player.vimeo.com/video/263001666",
    // OrganisationExpenses: "https://player.vimeo.com/video/328398856",
    PreApprovals:
        "https://www.youtube.com/embed?list=PLugzlMICZR8hgG0Xn1hSCL-gLOjaX2Nko",
    // PreApprovalOneStepApproval: "https://player.vimeo.com/video/354194593",
    // VendorOneStepApproval: "https://player.vimeo.com/video/349615323",
    // VendorTwoStepApproval: "https://player.vimeo.com/video/340645071",

    // AssignEmployeestoGrades: "https://player.vimeo.com/video/261474956",
    TwoStepApproval:
        "https://www.youtube.com/embed?list=PLugzlMICZR8iSnflUbVvgy7AzEOtrZZPe",
    // VendorManagement: "https://player.vimeo.com/video/331798946",
    SetupCostCentres:
        "https://www.youtube.com/embed?list=PLugzlMICZR8ilsHJDwjQu0tUjEcb5pjbV",
    // AssignCostCentres: "https://player.vimeo.com/video/261475098",
    SetupImportCc: "https://www.youtube.com/embed/videoseries?si=m9Py6nPon6oeiLtm&amp;list=PLugzlMICZR8gLwyl514FxmLgiLzs3_6Mh",
    AssignCcToClaimants: "https://www.youtube.com/embed/videoseries?si=0pur9LNzho12_Ncr&amp;list=PLugzlMICZR8ggxE-PUxvbhe0G6VTlG4TP",
    SetupDisplayNameCodeOfCc: "https://www.youtube.com/embed/videoseries?si=ZfudOeeuSayinJnd&amp;list=PLugzlMICZR8hBYghQrLcehcbv75IHnb9h",
    SetupCustomer: "https://www.youtube.com/embed/videoseries?si=mPX-lPNWWbPUikZ4&amp;list=PLugzlMICZR8j2_twdPqXebwcc5jzrF10y",
    SetupCcAccessRights: "https://www.youtube.com/embed/videoseries?si=k1RmKudl-RcNXeg4&amp;list=PLugzlMICZR8jUYagbgW6oc6A--wReKU3h",
    ActivateClaimantsWhoCanDelegate: "https://www.youtube.com/embed/videoseries?list=PLugzlMICZR8hJGhS5hK7znXTgS0r7clCU",
    ActivateClaiamantsWhoWillDoTheWork: "https://www.youtube.com/embed/videoseries?si=-z9mOXtb03SlpWTs&amp;list=PLugzlMICZR8jlXOBBj0Ap7WkzSvNQxHBa",
    ManageDelegatorsAndDelegates: "https://www.youtube.com/embed/videoseries?si=V-ng4XMniKNyRlTX&amp;list=PLugzlMICZR8gP215pkqu1pXGve07YOXS8",
    ExpenseCategoryManagement:
        "https://www.youtube.com/embed?list=PLugzlMICZR8hcvfcGEtf9plQjk8_k_qNF",
    // TaxRatewithComponents: "https://www.youtube.com/embed?list=PLugzlMICZR8hPjKl1Lgzxf-xrO5HOYqxp",
    TaxRatewithoutComponents:
        "https://www.youtube.com/embed?list=PLugzlMICZR8jQf-Yv7a_ij2es0q1f2Plj",
    TaxRatewithComponents:
        "https://www.youtube.com/embed?list=PLugzlMICZR8hPjKl1Lgzxf-xrO5HOYqxp",
    // GeneralSettings: "https://player.vimeo.com/video/261764790",
    // GeneralSettingsINR: "https://player.vimeo.com/video/349615817",
    AssignTaxtoCategories:
        "https://www.youtube.com/embed?list=PLugzlMICZR8hVIObATldvjwKV4WbigeXA",
    // SetupPolicyAssigntoGrades: "https://player.vimeo.com/video/261764877",
    //SetupUKMileageRates: "https://www.youtube.com/embed?list=PLugzlMICZR8i85Rrw4e_eMmk-WED8arEj",
    //VehicleManagement: "https://player.vimeo.com/video/277604380",
    // Triangulation: "https://player.vimeo.com/video/277408514",
    // ExportDatatoOtherSystems: "https://www.youtube.com/embed?list=PLugzlMICZR8jpha9c7VwDIcZr362dlWvU",
    // ExpensesTwoStepApproval: "https://player.vimeo.com/video/356119256",
    Tally:
        "https://www.youtube.com/embed?list=PLugzlMICZR8hy4xVveaMWJUwlUmeEoytj",
    Xero:
        "https://www.youtube.com/embed?list=PLugzlMICZR8jbh5JqouUMyPiZKuuD2NuW",
    QuickBooks:
        "https://www.youtube.com/embed?list=PLugzlMICZR8jK2xFlslYF9JgAcD3vQ8E4",
    Sage50:
        "https://www.youtube.com/embed?list=PLugzlMICZR8hjHBNvbeuQegUAdrTSueZL",
    // CardDismissedTransactions: "https://player.vimeo.com/video/262785095",
    // CardImportStatement: "https://player.vimeo.com/video/262785095",
    CardSetup:
        "https://www.youtube.com/embed?list=PLugzlMICZR8iMgRqlA9_YnQs6iP5kUd1R",
    // CardAssignClaimant: "https://player.vimeo.com/video/262785095",
    // CardAssignClaimantImport: "https://player.vimeo.com/video/262785095",
    // CardImportTemplate: "https://player.vimeo.com/video/262785095",
    // CardRegister: "https://player.vimeo.com/video/262785095",
    // CardRules: "https://player.vimeo.com/video/262785095",
    ExpenseExport:
        "https://www.youtube.com/embed?list=PLugzlMICZR8jpha9c7VwDIcZr362dlWvU",
    // ExpenseExportLog: "https://player.vimeo.com/video/263490841",
    // ImportCostCentre: "https://player.vimeo.com/video/261475098",
    // ImportGrades: "https://player.vimeo.com/video/261474956",
    InvoicesSubscription:
        "https://www.youtube.com/embed?list=PLugzlMICZR8ilLjOuUJtGOj26TJV8kUJF",
    // ChangePassword: "https://player.vimeo.com/video/259328865",
    // TaxRateSetup: "https://www.youtube.com/embed?list=PLugzlMICZR8jQf-Yv7a_ij2es0q1f2Plj",
    TaxSetup:
        "https://www.youtube.com/embed?list=PLugzlMICZR8hHTK79mU4k39_bzPAt-tdG",
    CreateNewReport:
        "https://www.youtube.com/embed?list=PLugzlMICZR8h0wbNnGuG2Evba_gi4-pKz",
    Pricing:
        "https://www.youtube.com/embed?list=PLugzlMICZR8hgpmcS5TIRwAkdTAySO8nH",
    // ExistingReport:"https://player.vimeo.com/video/259328865",
    // ExportLog: "https://player.vimeo.com/video/259328865",
    // EditExistingReport:"https://player.vimeo.com/video/259328865",
    // YesBankImportEmployees:"https://player.vimeo.com/video/259328865",
    BillingPlan: "https://www.youtube.com/embed?list=PLugzlMICZR8j8LsVW8WNTvDU6ncDc-3XX",
    // YesBankRegistration:"https://player.vimeo.com/video/259328865",
    // AssignCodesToEmpoyeesTally:"https://player.vimeo.com/video/259328865",
    // AssignCodesToEmpoyeesXero:"https://player.vimeo.com/video/259328865",
    // AssignCodesToEmpoyeesQuickBooks:"https://player.vimeo.com/video/259328865",
    // AssignCodesToEmpoyeesSage50:"https://player.vimeo.com/video/259328865",
    // AssignCodesToTaxTally:"https://player.vimeo.com/video/259328865",
    // AssignCodesToTaxXero:"https://player.vimeo.com/video/259328865",
    // AssignCodesToTaxQuickBooks:"https://player.vimeo.com/video/259328865",
    // AssignCodesToTaxSage50:"https://player.vimeo.com/video/259328865",
    // AssignCodesToCategoryTally:"https://player.vimeo.com/video/259328865",
    // AssignCodesToCategoryXero:"https://player.vimeo.com/video/259328865",
    // AssignCodesToCategoryQuickBooks:"https://player.vimeo.com/video/259328865",
    // AssignCodesToCategorySage50:"https://player.vimeo.com/video/259328865",
    // AssignCodesToCostCentreTally:"https://player.vimeo.com/video/259328865",
    AdvancesSetup:
        "https://www.youtube.com/embed?list=PLugzlMICZR8jzUQtcFqq7gSmFFrSRscHx",
    TriangulationOfficeNameAddress:
        "https://www.youtube.com/embed/videoseries?si=RSOgIX-G87UVOYtl&list=PLugzlMICZR8ipcn-VkuqE2agq9yTmnCT5",
    SetupAdvancedMileage:
        "https://www.youtube.com/embed/videoseries?si=UgA9foHxC5MeXGhx&list=PLugzlMICZR8hM_iQOsV2vZr7_Unp1HkB1",
    // TriangulationSetupOfficeWorker: "https://www.youtube.com/embed?list=PLugzlMICZR8hDkkL8C-IvsWPkcpYdC_li",
    SetupUkHMRCCompliantRates:
        "https://www.youtube.com/embed/videoseries?si=Ul2Bbs4ub4d1GBCY&list=PLugzlMICZR8jgoNt-Fw7fo0vNwXlpCNE3",
    //UkMileageQuickAssignment: "https://player.vimeo.com/video/259328865",
    AssignVehicleToClaimants:
        "https://www.youtube.com/embed?list=PLugzlMICZR8hutwJrmhzNSIz5xZQuCH3t",
    //TriangulationSetupHomeWorker: "https://player.vimeo.com/video/259328865",
    SetupUkHMRCCompliantRatesDefault:
        "https://www.youtube.com/embed?list=PLugzlMICZR8i85Rrw4e_eMmk-WED8arEj",
    // ReviewYourOrder:"https://player.vimeo.com/video/259328865",
    // ShoppingCart: "https://player.vimeo.com/video/259328865",
    // PayAllExpenses: "https://player.vimeo.com/video/259328865",
    // PayExpenses: "https://player.vimeo.com/video/259328865"
    SetupExpensePolicy:
        "https://www.youtube.com/embed?list=PLugzlMICZR8jXvAN5f1EvUB7AyJRypKMT",
    AssignVehicleToClaimantsAdvance:
        "https://www.youtube.com/embed/videoseries?si=m8I8ST0ZrXa4xpU0&list=PLugzlMICZR8hTGoxC34WnHFrZzK-KpNtj",
    SetupCustomers:
        "https://www.youtube.com/embed?list=PLugzlMICZR8j2_twdPqXebwcc5jzrF10y",
    BusinessPurpose:
        "https://www.youtube.com/embed?list=PLugzlMICZR8gi5K4QXMTg3zcup8O7s67S",
    Liability:
        "https://www.youtube.com/embed?list=PLugzlMICZR8g7fNpAzhCNseWAiw9WN85_",
    SetupSingleRate:
        "https://www.youtube.com/embed/videoseries?si=SAUGxa43U_OKgQxt&list=PLugzlMICZR8h3-KzXWGrCUVH26fqdTEg9",
    AuditTrail:
        "https://www.youtube.com/embed?list=PLugzlMICZR8hWc9deP5yno-atGRN3P1RG",
    ManualVat:
        "https://www.youtube.com/embed?list=PLugzlMICZR8gDd7IfhywiQ4IJmTdr8xpw",
    SetupDifferentialRate:
        "https://www.youtube.com/embed/videoseries?si=HQiodL6uw6P_7ZrY&list=PLugzlMICZR8h2frYDzr11lqrFus-s-_9W",
    AdditionalFields:
        "https://www.youtube.com/embed?list=PLugzlMICZR8ggNu0tZIebglBFI6hz8-_k",
    ExpenseSubmissionTimeLimit:
        "https://www.youtube.com/embed?list=PLugzlMICZR8ic0ocSdPVI3Ieg6mVUETS3",
    vatnovat:
        "https://www.youtube.com/embed?list=PLugzlMICZR8grqvMQaqkK8a0G2q2yM_s3",
    SecondaryFM:
        "https://www.youtube.com/embed?list=PLugzlMICZR8ibsirN72ndbtQPNBFFyD2y",
    AutoApproval:
        "https://www.youtube.com/embed?list=PLugzlMICZR8hIIpqTQNgZCrB-pFHluIg8",
    DuplicateRule:
        "https://www.youtube.com/embed?list=PLugzlMICZR8hNHNJcq0tWPTJiUUt-ZvHF",
    ExpenseCappingDaily:
        "https://www.youtube.com/embed?list=PLugzlMICZR8j1MUsoIvHd6rs4xQA-2iL3",
    ExpenseCappingMonthly:
        "https://www.youtube.com/embed?list=PLugzlMICZR8gZfTQsKibY3GOcu_ydQMNh",
    ExpenseCappingYearly:
        "https://www.youtube.com/embed?list=PLugzlMICZR8ifRNxVywYpA6A1jnV8d1e0",
    OverallDailyLimit:
        "https://www.youtube.com/embed?list=PLugzlMICZR8gagB4WsSdsbDXqidgeW4zl",
    ExpenseEscalationSettings:
        "https://www.youtube.com/embed?list=PLugzlMICZR8hgvVhaDbEycVtATxBi7_6f",
    PerPersonLimit:
        "https://www.youtube.com/embed?list=PLugzlMICZR8h7x5TW0TPJAEkTb6jKcUOd",
    PerNightLimit:
        "https://www.youtube.com/embed?list=PLugzlMICZR8iUjRhUBOln0MIsMxVt4xo9",
    nr:
        "https://www.youtube.com/embed/videoseries?si=4DZwxv2O_QrKoQ_W&list=PLugzlMICZR8h5B7jMihkr3zHt3wQndIjP",
    fc:
        "https://www.youtube.com/embed/videoseries?si=RQvuASxIu1UZMg3W&list=PLugzlMICZR8gW7onIC2g9VELShHnQp5V4",
    nrfcsetting:
        "https://www.youtube.com/embed/videoseries?si=bSRFFsrzOJPEWRN0&list=PLugzlMICZR8iz_L6wjRa-QbQMh8UBQMNX",
    ReferNEarn:
        "https://www.youtube.com/embed?list=PLugzlMICZR8gCNc_58XL5QeZmq1K6gaF-",
    AssignCategoryToGrade:
        "https://www.youtube.com/embed?list=PLugzlMICZR8h8q9H4qVPdLYOL5JdD0A7s",
    ApproverDeputy:
        "https://www.youtube.com/embed?list=PLugzlMICZR8gJ8-XD14ry-rDfxLyBfane",
    OutOfOffice:
        "https://www.youtube.com/embed?list=PLugzlMICZR8gJ8-XD14ry-rDfxLyBfane",
    ProjectBudgetSummary:
        "https://www.youtube.com/embed?list=PLugzlMICZR8gFSpGLX1-oT7RneSr6PZ72",
    MultipleCompanies: "https://www.youtube.com/embed?list=PLugzlMICZR8g56SykrpJTciUP__T6Q-96",
    AssignEmployeesToCompany: "https://www.youtube.com/embed?list=PLugzlMICZR8gtJyO2wD03X2zq0jZrGgf4",
    AssignMileageRateToGrade:
        "https://www.youtube.com/embed?list=PLugzlMICZR8gjhd-lMdKJuFl9jyl7POEu",
    AssignAccountCodeToCompany: "https://www.youtube.com/embed?list=PLugzlMICZR8iWrQ-pPwslPuR0MQ64WzG3",
    OpenAPIs: "https://www.youtube.com/embed?list=PLugzlMICZR8g1C-CjtppzcDpwC3h14hJm",
    MultipleCompaniesConfigureRules: "https://www.youtube.com/embed?list=PLugzlMICZR8hYsdlb0o-WjMQkik4MpTq7",
    MultipleCompaniesConfigureRulesSetup: "https://www.youtube.com/embed?list=PLugzlMICZR8g8hCUo3gNgJsqpxXpGchaI",
    ClaimantOnWebExpenseList: "https://www.youtube.com/embed?list=PLugzlMICZR8gHDyvsNBo-lDqEgKkl987j",
    ApproverHistoricalView:
        "https://www.youtube.com/embed?list=PLugzlMICZR8jNQlcGafNmyWp2S2uwPYpq",
    SetupLocation:
        "https://www.youtube.com/embed?list=PLugzlMICZR8hsfyXao5doXvCutaDVv1e2",
    AttendeeType: "https://www.youtube.com/embed?list=PLugzlMICZR8gl-UWwAjp30Z7PoSIaSxZM",
    DutyofCare: "https://www.youtube.com/embed/videoseries?si=sI3SssrQipvPSQhn&amp;list=PLugzlMICZR8jBIi-wm0f3phfvrCatppKK",
    ApproveDutyofCare: "https://www.youtube.com/embed?list=PLugzlMICZR8jXUrh1MNZI5Ub-r04xEgq7",
    MonthlyCappingClaimantWise: "https://www.youtube.com/embed?list=PLugzlMICZR8i3TdRLbRLz_BbcwqGB3t89",
    YearlyCappingClaimantWise: "https://www.youtube.com/embed?list=PLugzlMICZR8iRmFCFipzYgPGPY3J05uNt",
    SetupSupplier:
        "https://www.youtube.com/embed?list=PLugzlMICZR8gqxZuJA0_vBb99s_fYc1lz",
    UniversalEmployeesImportTemplate: "https://www.youtube.com/embed?list=PLugzlMICZR8gIyWPByVoc8qdAO_aAVlrT",
    LeaveManagement: "https://www.youtube.com/embed?list=PLugzlMICZR8iIDfqdeoedLBf7yAr_1ds8",
    UniversalImportTemplate: "https://www.youtube.com/embed?list=PLugzlMICZR8gIyWPByVoc8qdAO_aAVlrT",
    MultipleCountry: "https://www.youtube.com/embed/videoseries?list=PLugzlMICZR8g56SykrpJTciUP__T6Q-96",
    // ImportCreditCardStatement: "https://www.youtube.com/embed?list=PLugzlMICZR8iMgRqlA9_YnQs6iP5kUd1R",
    ImportCreditCardStatement: "https://www.youtube.com/embed/videoseries?si=M829NqpK6KSmx-wR&amp;list=PLugzlMICZR8jfwVk3EMowX1Y5Y0LzdQko",
    DiscountContractWork: "https://www.youtube.com/embed/videoseries?list=PLugzlMICZR8g6_yfaLnp88R6yXtE1o_Y4",
    DiscountAndCostControl: "https://www.youtube.com/embed/videoseries?list=PLugzlMICZR8izs6rCBoX7ktGQzSX2Wkjc",
    DiscountContract: "https://www.youtube.com/embed/videoseries?list=PLugzlMICZR8g6_yfaLnp88R6yXtE1o_Y4",
    MultipleVehicle: "https://www.youtube.com/embed/videoseries?si=1uu6fQxF0zi2oeEi&list=PLugzlMICZR8jnc8fMsaa7Mnddbaz7ppV4",
    AssignMultipleVehicle: "https://www.youtube.com/embed/videoseries?list=PLugzlMICZR8im5BHhmOfLiCaSV19UIGWX",
    PassengerLoadMiles: "https://www.youtube.com/embed/videoseries?si=3MxGRtDCulcvghnJ&list=PLugzlMICZR8giaJHas-WO5_pVYnKosTFD",
    AntiFraudMultiple: "https://www.youtube.com/embed/videoseries?list=PLugzlMICZR8jmoXJqin8g79cpRj6u9FpH",
    ComplianceStatement: "https://www.youtube.com/embed/videoseries?list=PLugzlMICZR8gaEGXfDSg1U5j0S0ZFCxD8",
    ImportEmployees: "https://www.youtube.com/embed/videoseries?list=PLugzlMICZR8gdDNJa_qn32n5Kuym-9H3l",
    CashAdvance: "https://www.youtube.com/embed/videoseries?list=PLugzlMICZR8jKrw9mx5GGb728myVg0m1w",
    Sage200: "https://www.youtube.com/embed/videoseries?list=PLugzlMICZR8hCen_H_LOoSOLRzjLNR2wg",
    ExpenseCategorySetup: "https://www.youtube.com/embed/videoseries?list=PLugzlMICZR8hTbum8jgz4Lcpx6zCoCyc-",
    ImportCategories: "https://www.youtube.com/embed/videoseries?list=PLugzlMICZR8iOcwNioBvKSKWN3ybgKQ8I",
    ForgotPassword: "https://www.youtube.com/embed/clAvwbrw4B0",
    DelegateSetup: "https://www.youtube.com/embed/videoseries?list=PLugzlMICZR8hJGhS5hK7znXTgS0r7clCU",
    CounterApprover: "https://www.youtube.com/embed/videoseries?list=PLugzlMICZR8iV-_QBkNpzkt9-IIZhDv1F",
    DelegateAssign: "https://www.youtube.com/embed/videoseries?list=PLugzlMICZR8i1tdCkZuEg1F1jyTLrF5CX",
    CreateDelegatorsExpense: "https://www.youtube.com/embed/videoseries?list=PLugzlMICZR8hdKSYq1yCazGPaGjjVYd_j",
    ImportExportMileageRates: "https://www.youtube.com/embed/videoseries?list=PLugzlMICZR8jOjaa0SDL6HOV7PIqxEZ9n",
    FxRate: "https://www.youtube.com/embed/videoseries?list=PLugzlMICZR8j13aCPiLkMYeGm81IFU0bZ",
    YearEndRule: "https://www.youtube.com/embed/videoseries?list=PLugzlMICZR8hoBoMeh1HyOxYILTQgGug-",
    ImportDeputies: "https://www.youtube.com/embed/videoseries?list=PLugzlMICZR8g0aPnWtjuOAjnYlCyyud8P",
    ImportVehicles: "https://www.youtube.com/embed/videoseries?list=PLugzlMICZR8jwauIDhq9on93g8zFWiKCY",
    ImportHomePostcodes: "https://www.youtube.com/embed/videoseries?list=PLugzlMICZR8haaWLvWbtZZhxqIWj6Tg8q",
    ImportMileageRates: "https://www.youtube.com/embed/videoseries?list=PLugzlMICZR8jOjaa0SDL6HOV7PIqxEZ9n",
    APAutomation: "https://www.youtube.com/embed/videoseries?list=PLugzlMICZR8jr0IZ17rzErxaU6qDXa3fC",
    ApproverKYC: "https://www.youtube.com/embed/videoseries?list=PLugzlMICZR8jKyry-fW4Jy_fgMT3KhDus",
    AssignApproversToCostCentre: "https://www.youtube.com/embed/videoseries?list=PLugzlMICZR8gGLwEGCVmcpax2pR6YCS4-",
    DisappearingExpense: "https://www.youtube.com/embed/videoseries?list=PLugzlMICZR8jtohXf2n_07Mvh5nDxDWhz",
    CarbonFootprint: "https://www.youtube.com/embed/videoseries?list=PLugzlMICZR8j3ln8EwoEOUa8oOC8ehvls",
    SSO: "https://www.youtube.com/embed/videoseries?list=PLugzlMICZR8h4Yl1TfJf-kgh27TBcbCeh",
    FMCanEditExpense: "https://www.youtube.com/embed/videoseries?si=4YfFxNpPJbqP1zNo&amp;list=PLugzlMICZR8gyUQ4TxywbrgsZpguxlVkC",
    AssignGradetoClaimants: "https://www.youtube.com/embed/videoseries?si=iqww7ImIQD0UspKo&amp;list=PLugzlMICZR8gzXqL-76AXQSBureYY4rc2",
    ImportGrade: "https://www.youtube.com/embed/videoseries?si=kDxwrFipr_wn18aD&amp;list=PLugzlMICZR8gShWpE9Z9GsVKYt5Kj5dlr",
    GradeWizard: "https://www.youtube.com/embed/videoseries?list=PLugzlMICZR8i9SxQzHjyOrXHUcldv8Rwx",
    SetupGrades: "https://www.youtube.com/embed/videoseries?si=QxiOvjAsZHmgmekE&amp;list=PLugzlMICZR8i9SxQzHjyOrXHUcldv8Rwx",
    ImportGrades: "https://www.youtube.com/embed/videoseries?si=fv4mNrkiKDBxErT9&amp;list=PLugzlMICZR8gShWpE9Z9GsVKYt5Kj5dlr",
    Container: "https://www.youtube.com/embed/videoseries?si=H40sClb5HyQ6ka8A&amp;list=PLugzlMICZR8jwvUT66Fzb-oLQUF90qcfp",
    AddSetupAndManageEmployees: "https://www.youtube.com/embed/videoseries?si=5P6FlyZ-DUukv10l&amp;list=PLugzlMICZR8iepD3e_NdmiBl8C6TjA33P",
    ManageEmployeesImportEmployees: "https://www.youtube.com/embed/videoseries?si=bibEMDjgTmj2rAe1&amp;list=PLugzlMICZR8gdDNJa_qn32n5Kuym-9H3l",
    ImportExportExpenseCategories: "https://www.youtube.com/embed/videoseries?si=pRdtrQrEibRGu2Xh&amp;list=PLugzlMICZR8iOcwNioBvKSKWN3ybgKQ8I",
    SetupAdditionalField: " https://www.youtube.com/embed/videoseries?list=PLugzlMICZR8ggNu0tZIebglBFI6hz8-_k",
    Assignfieldtocategoriesstep5: "https://www.youtube.com/embed/videoseries?si=j9QYh59EIew_Rejx&amp;list=PLugzlMICZR8iy1XoCo011LA86_6Rdi7Wj",
    RollBackExportedExpenses: "https://www.youtube.com/embed/videoseries?si=HTKgk-1ffmuJhf9P&amp;list=PLugzlMICZR8jT4MgsQpZy1Pa7zOCe8rek",
    ccSetupStep1: "https://www.youtube.com/embed/videoseries?si=Axbic7gWNWPjmCQH&amp;list=PLugzlMICZR8h86IB6jr9FCO_3p3vd5REn",
    ccSetupStep2: "https://www.youtube.com/embed/videoseries?si=qw-5PtvGioEvIW4Q&amp;list=PLugzlMICZR8iT44ujSFS4sv_EtlA2JYc2",
    ccSetupStep3: "https://www.youtube.com/embed/videoseries?si=31oL5cbINB81pIGa&amp;list=PLugzlMICZR8iQsUvIswG11PJ8P9aHqsE9",
    ccSetupStep4: "https://www.youtube.com/embed/videoseries?si=rjk95M_hCL2yVhPb&amp;list=PLugzlMICZR8irf6KkH6m62OJhQbPBhW2e",
    ccSetupStep5: "https://www.youtube.com/embed/videoseries?si=byPopj3dORUSAXAl&amp;list=PLugzlMICZR8hr4PxyslEkROcLd-0eXHlZ",
    ccSetupStep6: "https://www.youtube.com/embed/videoseries?si=D1y8lAM2Jxy1hvX0&amp;list=PLugzlMICZR8j71sQPGGfT_FQK7ChGnA9t",
    ccSetupStep7: "https://www.youtube.com/embed/videoseries?si=2LQzWCTXs4pfW189&amp;list=PLugzlMICZR8gCFijjHevAChpeItdUVkDf",
    ccSetupStep8: "https://www.youtube.com/embed/videoseries?si=Ebz3TUnjey_INdD1&amp;list=PLugzlMICZR8g1WkeDZHhKrSH1ylx_VQUw",
    ConfigureNamesOfRecieptTypes: "https://www.youtube.com/embed/videoseries?si=AhYeYc4isvscyusX&amp;list=PLugzlMICZR8jz4Be6RPJCXUmZ06YbA-A1",
    TurnOnReceiptTypeDisplayToClaimant: "https://www.youtube.com/embed/videoseries?si=HjZ-6080rOPkhQ5o&amp;list=PLugzlMICZR8h_QT1WyHVmv_kNnQ6Amamz",
    ConfigurePolicyViolationTaxNoTax: "https://www.youtube.com/embed/videoseries?si=m3xokw7Otg6TlTjX&amp;list=PLugzlMICZR8ioC18HU5IRPIentcu4T9SN",
    EnableRecieptNumberCapture: "https://www.youtube.com/embed/videoseries?si=MOf9EUXQ_dXBhjc&amp;list=PLugzlMICZR8i8OJHmT27E6uFwpZ9E4Dmd",
    SpecialCatStep1: "https://www.youtube.com/embed/videoseries?si=KD23YIoIYbiJcwmK&amp;list=PLugzlMICZR8gQKUyIP3nAGieONXKPxXvE",
    SpecialCatStep2: "https://www.youtube.com/embed/videoseries?si=F7JyC9V2XeCq5K5C&amp;list=PLugzlMICZR8j7yYAUPMABV-G2zwoI9rAT",
    SpecialCatStep3: "https://www.youtube.com/embed/videoseries?si=LfWl_vP5FVyflJ7Z&amp;list=PLugzlMICZR8gYEvtjUxBDFu0bDCmLdxr9",
    SpecialCatStep4: "https://www.youtube.com/embed/videoseries?si=W8eSrJG46XbUYIQY&amp;list=PLugzlMICZR8ghrg22zUuj7ChfKEi8c0Wi",
    XeroSetupStep2: "https://www.youtube.com/embed/videoseries?si=qJ9lPHchS3T_opUT&amp;list=PLugzlMICZR8gWN9Z6ggzZ1i0b01BVN2VZ",
    XeroSetupStep3: "https://www.youtube.com/embed/videoseries?si=ldAGInECAVEjEOQm&amp;list=PLugzlMICZR8g4eCPEZmC-l-Y8kmo3YQeE",
    XeroSetupStep4: "https://www.youtube.com/embed/videoseries?si=rosmwUngQ_pI6ONv&amp;list=PLugzlMICZR8hs44JTFDXZnVVcKnvhjurx",
    XeroSetupStep5: "https://www.youtube.com/embed/videoseries?si=lS7aNY_ywEw8nNoF&amp;list=PLugzlMICZR8jsL97CjujT-dND1WPHv7WN",
    XeroSetupStep6: "https://www.youtube.com/embed/videoseries?si=-dQXmqbxLjaSJEY1&amp;list=PLugzlMICZR8j80o03o3sxZTh7Uc7isqcp",
    XeroSetupStep7: "https://www.youtube.com/embed/videoseries?si=drq8CRANtoFyXqcw&amp;list=PLugzlMICZR8jzlhh-Eg_JvVTx4w8IKLXq",
    XeroSetupStep8: "https://www.youtube.com/embed/videoseries?si=DeJa22C38i_pEXW6&amp;list=PLugzlMICZR8jotRxst3pZTrzt1Q8guzW8",
    XeroSetupStep9: "https://www.youtube.com/embed/videoseries?si=-j1IeYPaoon3t3an&amp;list=PLugzlMICZR8gN0J9aizg33WEFIQsgZMh5",
    XeroSetupStep10: "https://www.youtube.com/embed/videoseries?si=C6QYjHtObtsny0Ma&amp;list=PLugzlMICZR8jxbAOrHr06Fy3UVYKzF7aO",
    XeroSetupStep11: "https://www.youtube.com/embed/videoseries?si=PF9jmwdIuFLc5s5w&amp;list=PLugzlMICZR8iEMHpkWck7ZXCfktXzvjT-",
    XeroSetupStep12: "https://www.youtube.com/embed/videoseries?si=Uj3bRZlb8PmA6OoI&amp;list=PLugzlMICZR8ifd7nWLLRNzIiULELKpqN5",
    XeroSetupStep13: "https://www.youtube.com/embed/videoseries?si=_8BBS7qdFplHDo0U&amp;list=PLugzlMICZR8ixKcV9T6VTB_BMeWrIA_ni",
    TaxSetupStep1: "https://www.youtube.com/embed/videoseries?si=1gOBvaS-4VbvBW8k&amp;list=PLugzlMICZR8hZjQHBelReNf76EXT44TTB",
    TaxSetupStep2: "https://www.youtube.com/embed?list=PLugzlMICZR8hHTK79mU4k39_bzPAt-tdG",
    TaxSetupStep4: "https://www.youtube.com/embed/videoseries?si=7KUcaFM0uOH8XqNO&amp;list=PLugzlMICZR8i_piXkk6xw9_bPviqinyss",
    TaxRateSetupStep3withoutComponents:
        "https://www.youtube.com/embed?list=PLugzlMICZR8jQf-Yv7a_ij2es0q1f2Plj",
    TaxRateSetupStep3withComponents:
        "https://www.youtube.com/embed?list=PLugzlMICZR8hPjKl1Lgzxf-xrO5HOYqxp",
    VatnovatStep1: "https://www.youtube.com/embed/videoseries?si=8KXjvfN7gX6TkeI-&amp;list=PLugzlMICZR8gisSnWR2GD6qwLA7XSeP6H",
    VatnovatStep5: "https://www.youtube.com/embed/videoseries?si=yrdOz21OpRUZ5QK7&amp;list=PLugzlMICZR8jDrY7MQsLh719UmbPGqbbh",

    BuildReportWizardStep1: "https://www.youtube.com/embed/videoseries?si=_ZqhM74qsuez_39B&amp;list=PLugzlMICZR8gpJHPvEPSN3j6Ah-1AFuIV",
    BuildReportWizardStep2: "https://www.youtube.com/embed/videoseries?si=Sef18b6eDJ2U4CRx&amp;list=PLugzlMICZR8g4BmQmJZruzyHnov2FabYQ",
    BuildReportWizardStep3: "https://www.youtube.com/embed/videoseries?si=UMAoi0dU1QrDzFxU&amp;list=PLugzlMICZR8gSP6rHBUJAHB-sETHif5mw",

    QuickbooksWizardStep2: "https://www.youtube.com/embed/videoseries?si=MWMtbhDlb4zSnAbo&amp;list=PLugzlMICZR8hzZ5zhJiPpSx-FuZcQPc5t",
    QuickbooksWizardStep3: "https://www.youtube.com/embed/videoseries?si=o9lzLHCPhUtTQuie&amp;list=PLugzlMICZR8hc7myhf-__T83PcLRjdCae",
    QuickbooksWizardStep4: "https://www.youtube.com/embed/videoseries?si=QDj1_KNztXmBhmJD&amp;list=PLugzlMICZR8gWbCZYCbQnVKIzc5c1Rq9Q",
    QuickbooksWizardStep5: "https://www.youtube.com/embed/videoseries?si=ubEQxnnG1pXXWpbX&amp;list=PLugzlMICZR8ilNIkOCZ5YlxbJwsavW5Fy",
    QuickbooksWizardStep6: "https://www.youtube.com/embed/videoseries?si=fOA2Qu1miTHcrSuO&amp;list=PLugzlMICZR8iLrA_Orm744dueZpETeovE",
    XeroWizardStep14: "https://www.youtube.com/embed/videoseries?si=-QgFxnWzmijAUSEh&amp;list=PLugzlMICZR8gIN3vRz1vaNLJKgzcIis9R",




    DutyofCareStep2: "https://www.youtube.com/embed/videoseries?si=aKvSg9NjUmrwkDNZ&amp;list=PLugzlMICZR8gK4f5wskljaAiEN_IDc_Hd",
    DutyofCareStep3: "https://www.youtube.com/embed/videoseries?si=iG45e6HdwqoHlAxZ&amp;list=PLugzlMICZR8g_Byioo-6u6Yc4Qd91FAuE",
    DutyofCareStep4: "https://www.youtube.com/embed/videoseries?si=0YmV-PRtVVdUC0eL&amp;list=PLugzlMICZR8g0kt2oKnUWjq3SjAcUwgPP",
    DutyofCareStep5: "https://www.youtube.com/embed/videoseries?si=RhRqe3e3YgT5Sf1I&amp;list=PLugzlMICZR8i2Q-ynNodXQdNXsi4gmD5Z",
    MFA: "https://www.youtube.com/embed/videoseries?si=AULZpJokrt1YL4FV&amp;list=PLugzlMICZR8h2Kb9y4K_lcWJJGRirkE8o",

    DeputyforApproverStep1: "https://www.youtube.com/embed/videoseries?si=zG8YQjSP4biBXE9E&amp;list=PLugzlMICZR8hcxIGTRCbCrG0DJlN4Ld69",
    DeputyforApproverStep2: "https://www.youtube.com/embed/videoseries?si=L0pULde0O-stwOoz&amp;list=PLugzlMICZR8jWRlJ8tIq55ikq_8U43Iqm",
    DeputyforApproverStep3: "https://www.youtube.com/embed/videoseries?si=SBSibeOXgaH6jOdF&amp;list=PLugzlMICZR8hH5NfaOH7eiOcb4WKL21dr",
    DeputyforApproverStep4: "https://www.youtube.com/embed/videoseries?si=3aJmVYRcxelNgKwT&amp;list=PLugzlMICZR8iKV3uK5vSzqOxMmJ9NdYFC",

    MultipleLevelCounterApproverStep1: "https://www.youtube.com/embed/videoseries?si=4iJBukxzSH2B9Eeb&amp;list=PLugzlMICZR8jDUxSUQe8zCz189TW-w7Kb",
    MultipleLevelCounterApproverStep2: "https://www.youtube.com/embed/videoseries?si=lEKonxIQsNaeEanZ&amp;list=PLugzlMICZR8hmpniRfjE-ogV-vZ-aTifX",
    MultipleLevelCounterApproverStep3: "https://www.youtube.com/embed/videoseries?si=DhdUgENXdoieTVwP&amp;list=PLugzlMICZR8jdl7vp_mjk_V-OIoatdLNJ",
    MultipleLevelCounterApproverStep4: "https://www.youtube.com/embed/videoseries?si=7XdX-PuF39PT3D4T&amp;list=PLugzlMICZR8jybTtRNLOuC9phsdz74z6h",
    MultipleLevelCounterApproverStep5: "https://www.youtube.com/embed/videoseries?si=5lbPB5OnvMo0SkH0&amp;list=PLugzlMICZR8jN1HDIz7YF0Hh9ECQCvU7X",
    MultipleLevelCounterApproverStep6: "https://www.youtube.com/embed/videoseries?si=kZQ6QNiL5t31JnS2&amp;list=PLugzlMICZR8h2XkOYotKMJar6vw4f0hnA",
    MultipleLevelCounterApproverStep7: "https://www.youtube.com/embed/videoseries?si=YTCjm8VkI742TSgf&amp;list=PLugzlMICZR8jcI4sFP9KuHI4iXkMUQErA",
    QuickBooksStep7: "https://www.youtube.com/embed/videoseries?si=wCuYW431BWhB2bwq&amp;list=PLugzlMICZR8iQpcdtbTSFBYaHCPCk5iYv",

    FxRateStep1: "https://www.youtube.com/embed/videoseries?si=XgiCC_o6VkoMV2Y9&amp;list=PLugzlMICZR8j3Pl10Vl1MT0QZ35KklDMI",
    FxRateStep2: "https://www.youtube.com/embed/videoseries?si=DGgLckbzJwAjxqpl&amp;list=PLugzlMICZR8gCFfF7txnmLhW-q0M7VXjt",
    FxRateStep3: "https://www.youtube.com/embed/videoseries?si=LjSG9tyHBwu7hFnw&amp;list=PLugzlMICZR8jQy9ooCNHwHLwoHqWwtrn- ",
    CarbonFootprintStep2: "https://www.youtube.com/embed/videoseries?si=hhH_Qdik6Tk_Y2uX&amp;list=PLugzlMICZR8hWCYoo_58hh9sVJhAp-Ety",
    CarbonFootprintStep3: "https://www.youtube.com/embed/videoseries?si=bNIta61WKp9QW5LV&amp;list=PLugzlMICZR8jwKq5kaeMw-JP19Z69Q0Wl",
    CarbonFootprintStep4: "https://www.youtube.com/embed/videoseries?si=DcTAy8nIP19HN_xU&amp;list=PLugzlMICZR8h2FJaYhZ6un1e6514s6nPl",
    CarbonFootprintStep5: "https://www.youtube.com/embed/videoseries?si=Cy1t4pZXzIpfEI5b&amp;list=PLugzlMICZR8hilX8vklgUt_YyfV0Q4XDB",

    AutoDeleteOldAndUnclaimedExpensesStep1: "https://www.youtube.com/embed/videoseries?si=IfFzg8Hqkrf56uUt&amp;list=PLugzlMICZR8jXWXMzGsxpnEjCfqH2UmvZ",
    AutoDeleteOldAndUnclaimedExpensesStep2: "https://www.youtube.com/embed/videoseries?si=tZqq5RhukkpyC3qE&amp;list=PLugzlMICZR8jEIR-6uaZjTmuL0bGKKQDM",
    QuickBooksDesktopStep1: "https://www.youtube.com/embed/videoseries?si=BDcqtpK5XiHiFlEI&list=PLugzlMICZR8iw46Y-AILZd0WEBKRoTCTs",
    QuickBooksDesktopStep2: "https://www.youtube.com/embed/videoseries?si=yvydTHE1J80Siyob&list=PLugzlMICZR8ivNAISN6DIXg0SdSYZ4SZ1",
    QuickBooksDesktopStep3: "https://www.youtube.com/embed/videoseries?si=cm7YiAA34DgmKo4-&list=PLugzlMICZR8jZ8UllujdbT1DFrE4DT9Rf",
    QuickBooksDesktopStep4: "https://www.youtube.com/embed/videoseries?si=xo-iKctpnTGWl1YX&list=PLugzlMICZR8ghxG9Ni5zIRReENMf4lDgp",
    QuickBooksDesktopStep5: "https://www.youtube.com/embed/videoseries?si=Ap9M92gHhlLWEHfh&list=PLugzlMICZR8gAoSN3RwEsLtBGziRIYS28",
    QuickBooksDesktopStep6: "https://www.youtube.com/embed/videoseries?si=xAavB_6u7uk0Ba3T&list=PLugzlMICZR8j4_84OmgtsoyxJPpUTbzZg",
    CreditCardGrantAccess: "https://www.youtube.com/embed/videoseries?si=Gj0p2pQX7R08zOvK&list=PLugzlMICZR8gFhKdO7kR94RL7vKAiD7n5",
    deputyOnOff: "https://www.youtube.com/embed/dNpbBRiZU04?si=nd43Oh-PqG71vlTf",
    costCentreCustomerOnOff: "https://www.youtube.com/embed/videoseries?si=z1usHZgzuaO04KgQ&list=PLugzlMICZR8hedmdGdcOqZcpucXoNj9mI",
    fmCanEditOnOff: "https://www.youtube.com/embed/videoseries?si=gMeNdgiCjt-nz1a3&list=PLugzlMICZR8g50H7TLkTDS9j2oeXiZCrU",
    receiptWithMultipleRatesOnOff: "https://www.youtube.com/embed/videoseries?si=htm-gcir5YZh-3o-&list=PLugzlMICZR8jlC72zUOZ5SypoCeDms1VF",
    ApAutomationStep1: "https://www.youtube.com/embed/videoseries?si=W0SFsSSToh2pFVlt&amp;list=PLugzlMICZR8j_SbwKK5fUr0O-bAw6EM2A",
    ApAutomationStep2: "https://www.youtube.com/embed/videoseries?si=IRQnMGR_ahHBIwtk&list=PLugzlMICZR8gkv4s-Ogpq4eI_bBqKSErL",
    ApAutomationStep3: "https://www.youtube.com/embed/videoseries?si=iTrIftu4z9FUPitc&list=PLugzlMICZR8ibi_9g84Blad9ngvJb5kZj",
    ApAutomationStep4: "https://www.youtube.com/embed/videoseries?si=jOhEmg6_KuZJ7q0C&list=PLugzlMICZR8g3foonvykKJFYfmAzekukz",
    ApAutomationStep5: "https://www.youtube.com/embed/videoseries?si=kIIHo5rI1KzFttyj&list=PLugzlMICZR8hKGWGk23ofIky4BtkxHF-L",
    ApAutomationStep8: "https://www.youtube.com/embed/videoseries?si=ul53Xi50ARi-kUDj&list=PLugzlMICZR8hBQWzMw1WqftNgHKlBL1_o",
    SetupAdditionalFieldsStep1: "https://www.youtube.com/embed/videoseries?si=uaPdnZK-6oOJoTAJ&list=PLugzlMICZR8ggNu0tZIebglBFI6hz8-_k",
    SetupAdditionalFieldsStep2: "https://www.youtube.com/embed/videoseries?si=oHrVuFWEgHDqFbiu&list=PLugzlMICZR8gOz2L6jTGp-p0SPv0tqwmT",
    SetupAdditionalFieldsStep3: "https://www.youtube.com/embed/videoseries?si=iVb7HPsT6t7sMFLw&list=PLugzlMICZR8iypHf9BLJpsuCa6OPaCOV3",
    SetupAdditionalFieldsStep4: "https://www.youtube.com/embed/videoseries?si=UKfUSru-crKDp5UJ&list=PLugzlMICZR8iWqa88z_X4mbxcWbKkU9li",
    DynamicsStep2: "https://www.youtube.com/embed/r_cTg26vxMM?list=PLugzlMICZR8jUPXlP8h2t1e3nPPHtoJcl",
    DynamicsStep3: "https://www.youtube.com/embed/videoseries?si=LvNt8pXDjaj3WEi2&list=PLugzlMICZR8hv6KcpGGirdYNf7KQZiCrR",
    DynamicsStep4: "https://www.youtube.com/embed/videoseries?si=CHO7Iw_3q3vOpJi6&list=PLugzlMICZR8gSkF6TVuCnlbgfoZYudyLG",
    DynamicsStep5: "https://www.youtube.com/embed/videoseries?si=XkenPcVFCLD1Glna&list=PLugzlMICZR8j5VyV0cqdB-eHakwvuZIxw",
    DynamicsStep6: "https://www.youtube.com/embed/videoseries?si=w_d3IuhNomby-BCn&list=PLugzlMICZR8gsc6zhRIDSn8mWtSTIaQ8Q",
    DynamicsStep7: "https://www.youtube.com/embed/videoseries?si=Xqm-ddt2c3gzGEw4&list=PLugzlMICZR8jMY9w6F3dywoiYbYohC_WE",
    DynamicsStep8: "https://www.youtube.com/embed/videoseries?si=zuII5kOEnYBmEITo&list=PLugzlMICZR8gecxw9wGqJf6maE-n4wwMR",
    DynamicsStep9: "https://www.youtube.com/embed/videoseries?si=fX52Pz9KVbCM9w4Y&list=PLugzlMICZR8grAfSCK-hRi_pRLueF0mAG",
    DynamicsStep10: "https://www.youtube.com/embed/videoseries?si=n-o-FXDdvwW-1LKr&list=PLugzlMICZR8hcw4-gd3wNgOdKmonscdUJ",
    DynamicsStep11: "https://www.youtube.com/embed/videoseries?si=0gmmINblnq2vtLVU&list=PLugzlMICZR8gkyGtMIFCKQUpz_KPVuEiK",
    SelfApprovel: "https://www.youtube.com/embed/videoseries?si=-Ioi_Pn3J_UpITvy&list=PLugzlMICZR8h0GBEU79JjbH8XpCvaqdgq",
    QuickBooksDesktopStep1TillExport: "https://www.youtube.com/embed/FX_XTEVf9Kc?si=1VbdxvrByY_Um61R",
    NetsuiteStep2: "https://www.youtube.com/embed/videoseries?si=QI3o9HsfHJrDPkWH&list=PLugzlMICZR8gkFEjx7_NVVTwtHp8Di1gs",
    NetsuiteStep3: "https://www.youtube.com/embed/Vt5Qn8dVBsM?si=Bwx6RbkMscBzrj5A",
    NetsuiteStep4: "https://www.youtube.com/embed/videoseries?si=yEYOX4yiQv0TcnMq&list=PLugzlMICZR8gd3GKbXAa_jQqd4hSscV31",
    NetsuiteStep5: "https://www.youtube.com/embed/videoseries?si=oaYL30Ae0cpFEbdj&list=PLugzlMICZR8ifhCj8oFgyM2qdzuxJPGQV",
    NetsuiteStep6: "https://www.youtube.com/embed/videoseries?si=ibdYrT2ZPhwYtVZv&list=PLugzlMICZR8gSedLK1khqYQThNsAPUQoc",
    NetsuiteStep7: "https://www.youtube.com/embed/videoseries?si=E3BZiH3rYRZcIPBj&list=PLugzlMICZR8iDGEL9j58BMMK26Y8RqwX2",
    NetsuiteStep8: "https://www.youtube.com/embed/videoseries?si=5bGho2uZrVlSSfD7&list=PLugzlMICZR8jggBu2bzPuB4glfnN7S7JM",
    NetsuiteStep9: "https://www.youtube.com/embed/videoseries?si=2y-PWyxNVN3XZ9O5&list=PLugzlMICZR8jr3Nj_csi5j3WKy0cDYqt_",
    NetsuiteStep10: "https://www.youtube.com/embed/videoseries?si=7hcMNTEqtGbxAgOO&list=PLugzlMICZR8h5sAUI2OtpGl2Ew6oHPCes",
    NetsuiteStep11: "https://www.youtube.com/embed/videoseries?si=J_ex3fmoWFxttXdD&list=PLugzlMICZR8i4KXQcF8vyKUi2FokB_QBr",
    NetsuiteStep12: "https://www.youtube.com/embed/videoseries?si=IoTfpg9YZCdJFuJB&list=PLugzlMICZR8gk5_NINXWWrO9GuB-1s5Pu",
    DynamicsTaxStep: "https://www.youtube.com/embed/videoseries?si=lb_5pJ5RMOXGxBJc&list=PLugzlMICZR8hhhGMkL6drAA-1NyWA_pf9",
    CC_Mapping_Type_For_Xero: "https://www.youtube.com/embed/videoseries?si=cj1xASVUiEUhBOIJ&amp;list=PLugzlMICZR8h5_hFA-kONj4MSFVeu6N83",
    MileageStep5: "https://www.youtube.com/embed/videoseries?si=HOa4BH1xYTgUCZe2&amp;list=PLugzlMICZR8gxS2z-MY1fry-7kyEHsZk8"
};

export const websiteURl = "https://www.expenseondemand.com/";
export const UTCDateTime = {
    getUTCDate(date) {
        var now_utc = Date.UTC(
            date.getUTCFullYear() < 0 ? date.getUTCFullYear() * -1 : date.getUTCFullYear(),
            date.getUTCMonth() < 0 ? date.getUTCMonth() * -1 : date.getUTCMonth(),
            date.getUTCDate() < 0 ? date.getUTCDate() * -1 : date.getUTCDate(),
            0,
            0,
            0
        );

        return now_utc;
    },
    getUTCTimeStamp(date: Date) {
        let dateNow = new Date();
        let incomingDate = date;
        let now_utc = 0;
        if (
            dateNow.getFullYear() == incomingDate.getFullYear() &&
            dateNow.getMonth() == incomingDate.getMonth() &&
            dateNow.getDate() == incomingDate.getDate()
        ) {
            now_utc = Date.UTC(
                dateNow.getUTCFullYear(),
                dateNow.getUTCMonth(),
                dateNow.getUTCDate(),
                dateNow.getUTCHours(),
                dateNow.getUTCMinutes(),
                dateNow.getUTCSeconds(),
                dateNow.getUTCMilliseconds()
            );
        }
        else {
            let incomingDate1 = date.setHours(dateNow.getHours());
            incomingDate1 = date.setMinutes(dateNow.getMinutes());
            incomingDate1 = date.setSeconds(dateNow.getSeconds());
            let newDate = new Date(incomingDate1)
            now_utc = Date.UTC(
                newDate.getUTCFullYear(),
                newDate.getUTCMonth(),
                newDate.getUTCDate(),
                newDate.getUTCHours(),
                newDate.getUTCMinutes(),
                newDate.getUTCSeconds(),
                newDate.getUTCMilliseconds()
            );
        }


        return now_utc;
    }
};
export const ConvertNonAsciiToAscii = {
    removeAccents(input) {
        if (input) {
            const pattern = /[\u00e0-\u00ff\u0100-\u017fàáâãäåæÀÁÂÃÄÅÆçÇèéêëÈÉÊËìíîïÌÍÎÏðÐñÑòóôõöøÒÓÔÕÖØùúûüÙÚÛÜýÝ]/g;
            const replacements = {
                "à": "a", "á": "a", "â": "a", "ã": "a", "ä": "a", "å": "a", "æ": "ae",
                "À": "A", "Á": "A", "Â": "A", "Ã": "A", "Ä": "A", "Å": "A", "Æ": "AE",
                "ç": "c", "Ç": "C",
                "è": "e", "é": "e", "ê": "e", "ë": "e",
                "È": "E", "É": "E", "Ê": "E", "Ë": "E",
                "ì": "i", "í": "i", "î": "i", "ï": "i",
                "Ì": "I", "Í": "I", "Î": "I", "Ï": "I",
                "ð": "d", "Ð": "D",
                "ñ": "n", "Ñ": "N",
                "ò": "o", "ó": "o", "ô": "o", "õ": "o", "ö": "o", "ø": "o",
                "Ò": "O", "Ó": "O", "Ô": "O", "Õ": "O", "Ö": "O", "Ø": "O",
                "ù": "u", "ú": "u", "û": "u", "ü": "u",
                "Ù": "U", "Ú": "U", "Û": "U", "Ü": "U",
                "ý": "y", "Ý": "Y"
            };

            return input.replace(pattern, match => replacements[match] || match);
        }
        else {
            return input;
        }

    }
}

export const CityConstant = [
    { id: 1, name: "Vilnius" },
    { id: 2, name: "Kaunas" },
    { id: 3, name: "Pavilnys", disabled: true },
    { id: 4, name: "Pabradė" },
    { id: 1, name: "Vilnius" },
    { id: 2, name: "Kaunas" },
    { id: 3, name: "Pavilnys", disabled: true },
    { id: 4, name: "Pabradė" },
    { id: 1, name: "Vilnius" },
    { id: 2, name: "Kaunas" },
    { id: 3, name: "Pavilnys", disabled: true },
    { id: 4, name: "Pabradė" },
    { id: 1, name: "Vilnius" },
    { id: 2, name: "Kaunas" },
    { id: 3, name: "Pavilnys", disabled: true },
    { id: 4, name: "Pabradė" },
    { id: 1, name: "Vilnius" },
    { id: 2, name: "Kaunas" },
    { id: 3, name: "Pavilnys", disabled: true },
    { id: 4, name: "Pabradė" },
    { id: 1, name: "Vilnius" },
    { id: 2, name: "Kaunas" },
    { id: 3, name: "Pavilnys", disabled: true },
    { id: 4, name: "Pabradė" },
    { id: 1, name: "Vilnius" },
    { id: 2, name: "Kaunas" },
    { id: 3, name: "Pavilnys", disabled: true },
    { id: 4, name: "Pabradė" },
    { id: 1, name: "Vilnius" },
    { id: 2, name: "Kaunas" },
    { id: 3, name: "Pavilnys", disabled: true },
    { id: 4, name: "Pabradė" },
    { id: 1, name: "Vilnius" },
    { id: 2, name: "Kaunas" },
    { id: 3, name: "Pavilnys", disabled: true },
    { id: 4, name: "Pabradė" },
    { id: 1, name: "Vilnius" },
    { id: 2, name: "Kaunas" },
    { id: 3, name: "Pavilnys", disabled: true },
    { id: 4, name: "Pabradė" },
    { id: 1, name: "Vilnius" },
    { id: 2, name: "Kaunas" },
    { id: 3, name: "Pavilnys", disabled: true },
    { id: 4, name: "Pabradė" },
    { id: 1, name: "Vilnius" },
    { id: 2, name: "Kaunas" },
    { id: 3, name: "Pavilnys", disabled: true },
    { id: 4, name: "Pabradė" },
    { id: 1, name: "Vilnius" },
    { id: 2, name: "Kaunas" },
    { id: 3, name: "Pavilnys", disabled: true },
    { id: 4, name: "Pabradė" },
    { id: 1, name: "Vilnius" },
    { id: 2, name: "Kaunas" },
    { id: 3, name: "Pavilnys", disabled: true },
    { id: 4, name: "Pabradė" },
    { id: 1, name: "Vilnius" },
    { id: 2, name: "Kaunas" },
    { id: 3, name: "Pavilnys", disabled: true },
    { id: 4, name: "Pabradė" },
    { id: 1, name: "Vilnius" },
    { id: 2, name: "Kaunas" },
    { id: 3, name: "Pavilnys", disabled: true },
    { id: 4, name: "Pabradė" },
    { id: 1, name: "Vilnius" },
    { id: 2, name: "Kaunas" },
    { id: 3, name: "Pavilnys", disabled: true },
    { id: 4, name: "Pabradė" },
    { id: 1, name: "Vilnius" },
    { id: 2, name: "Kaunas" },
    { id: 3, name: "Pavilnys", disabled: true },
    { id: 4, name: "Pabradė" },
    { id: 1, name: "Vilnius" },
    { id: 2, name: "Kaunas" },
    { id: 3, name: "Pavilnys", disabled: true },
    { id: 4, name: "Pabradė" },
    { id: 1, name: "Vilnius" },
    { id: 2, name: "Kaunas" },
    { id: 3, name: "Pavilnys", disabled: true },
    { id: 4, name: "Pabradė" },
    { id: 1, name: "Vilnius" },
    { id: 2, name: "Kaunas" },
    { id: 3, name: "Pavilnys", disabled: true },
    { id: 4, name: "Pabradė" },
    { id: 5, name: "Klaipėda" },
];
